var LocationUtils;
((LocationUtils2) => {
  LocationUtils2.hash = (window) => {
    return window.location.hash.replace("#", "");
  };
  LocationUtils2.hashPath = (window) => {
    return window.location.hash.replace("#", "").split("?")[0];
  };
  LocationUtils2.hashSearch = (window) => {
    const string = window.location.hash.replace("#", "").split("?")[1];
    return string ? `?${string}` : "";
  };
  LocationUtils2.hashQueryParams = (window) => {
    const s = window.location.hash.replace("#", "").split("?")[1] || "";
    return LocationUtils2.queryStringToMap(s);
  };
  LocationUtils2.path = (window) => {
    return window.location.pathname;
  };
  LocationUtils2.search = (window) => {
    return window.location.search || "";
  };
  LocationUtils2.pathQueryParamsObject = (window) => {
    return LocationUtils2.queryStringToObject(window.location.search.substring(1));
  };
  LocationUtils2.hashQueryParamsObject = (window) => {
    const s = window.location.hash.split("?").pop() ?? "";
    if (s.startsWith("#")) {
      return {};
    } else {
      return LocationUtils2.queryStringToObject(s);
    }
  };
  LocationUtils2.pathQueryParams = (window) => {
    return LocationUtils2.queryStringToMap(window.location.search.substring(1));
  };
  LocationUtils2.queryStringToMap = (s) => {
    const params = /* @__PURE__ */ new Map();
    const vars = s.split("&") || [];
    vars.forEach((it) => {
      const kv = it.split("=") || [];
      if (kv[0] && kv[0].length > 0) {
        params.set(kv[0], kv[1]);
      }
    });
    return params;
  };
  LocationUtils2.queryStringToObject = (s) => {
    const params = {};
    const vars = s.split("&") || [];
    vars.forEach((it) => {
      const kv = it.split("=") || [];
      if (kv[0] && kv[0].length > 0) {
        params[kv[0]] = kv[1];
      }
    });
    return params;
  };
})(LocationUtils || (LocationUtils = {}));
export {
  LocationUtils
};
//# sourceMappingURL=LocationUtils.js.map
